var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbar-item-box"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"hand",on:{"click":function($event){return _vm.handleTapTab(item, index)}}},[_c('span',[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"divider",class:{ active: _vm.current === index }})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }